import { ThemeProvider } from "@material-ui/core";
import i18next from "i18next";
import React from "react";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { store } from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";
import "./translation/index";
import { theme } from "./utils/ThemeConfig";
require("dotenv").config();

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <I18nextProvider i18n={i18next}>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </I18nextProvider>
  </ThemeProvider>,
  document.getElementById("root")
);

reportWebVitals();

serviceWorker.register();
